export default __webpack_public_path__ + "72f4fd3dc889276124087d629ba73c44.png";